<template>
	<el-dialog :title="pageTitle" :visible="showDialog" :show-close="false">
		<el-form ref="reviewForm" :model="reviewForm" :rules="rules" label-width="140px" class="has-disabledField">
			<el-form-item label="是否复议" prop="type" :error="error.type" required>
                <el-select v-model="reviewForm.type" placeholder="请选择" style="width:100%;">
                    <el-option
                      v-for="o in reviewType"
                      :key="o.value"
                      :label="o.name"
                      :value="o.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="建议金额" prop="advicePrice" v-if="false" :error="error.advicePrice" required>
              	<el-input v-model="reviewForm.advicePrice">
                  	<template slot="append">元</template>
              	</el-input>
	        </el-form-item>
	        <el-form-item label="退回节点" prop="backNode" v-if="reviewForm.type == 1" :error="error.backNode" required>
                <el-select v-model="reviewForm.backNode" placeholder="请选择" style="width:100%;">
                    <el-option
		                v-for="item in backNodeList"
		                :key="item.order_node_id"
		                :value="item.order_node_id"
		                :label="item.node_name">
		            </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="建议原因" prop="mark" v-if="reviewForm.type == 1" :error="error.mark" required>
                <el-input type="textarea" v-model="reviewForm.mark" style="width:100%;"></el-input>
            </el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
	        <el-button @click="showDialog = false">取 消</el-button>
	        <el-button type="primary" @click="submit" :loading="submitLoading">确 定</el-button>
	    </div>
	</el-dialog>
</template>
<script>
import $ from 'jquery'
import async from 'async'
import _ from 'lodash'
import _this from '../../../lib/car/form/storeReviewWin'

let _p = window.xwCommon,
    pageTitle = _this.title,
    name = _this.name,
    methods = {
    	submit(){
    		this.$refs["reviewForm"].validate((valid) => {
	          if(valid) _this.submit(this)
	          else this.$alert("表单存在错误，请修正后再保存！",pageTitle)
	        })
    	}
    }

export default {
    name, methods, 
    props:{
    	"visible":{type:Boolean, default:false },
    	"info":{type:Object, required:true},
    	"node":{type:Object, required:true}
    },
    data: () => { return {
    	pageTitle, showDialog:false, submitLoading:false,
    	reviewType:_p.getStoredProp("_/default/judge/reviewType"),
    	backNodeList:[], reviewForm:{}, error:{}, rules:_this.rules
    } },
    watch:{
        visible:function(val){
            if(val){
                //_this.initWin(this)
            }else
                this.showDialog = false
        },
        showDialog:function(val){
            if(!val) this.$emit('closed')
        }
    },
    mounted(){
        _this.initWin(this)
        //console.log("hell")
    }
}
</script>


// WEBPACK FOOTER //
// storeReviewWin.vue?28539534